import { io } from 'socket.io-client';
import config from './config';
let whoAmIToken = localStorage.getItem('WOH_AM_I_DATA')
whoAmIToken = JSON.parse(whoAmIToken)

export const socketIO = io(config.WS_BASE_URL, {
	withCredentials: true, 
	forceNew:true,
	extraHeaders:{
	  Authorization: 'Bearer '+whoAmIToken?.data
	} 
});